import React, { Component } from 'react';
import { Trans } from "react-i18next";

import { NavLink } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Swiper from 'react-id-swiper';
import axios from 'axios';
import Cookies from 'universal-cookie';
import SideBar from "./SideBar";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next"; 

import ls from "local-storage"; 
import { options } from "../../config/options";
//import {creditimg} from "../../assets/img/sub-3.png";
const scratchcard=require('../../assets/img/scratchcard1.png');


class ScratchCard extends Component { 
    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
          this.onChangeScratch = this.onChangeScratch.bind(this);

          this.onChangeCoupon = this.onChangeCoupon.bind(this);

           this.paywithscratchcard = this.paywithscratchcard.bind(this);

            this.homeLink = this.homeLink.bind(this);   
        this.state = {
            credits:'0',
           api_url:localStorage.getItem('api_url'),
             showNav3: false,user_details:'',
             payment_type:'',
             scratchinputvalue:'',
             couponinputvalue:'',
              message:'',
            modal:'',
             lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),
            isError:false,
            isErrorc:false,
            regexp : /^[-\b0-9\b]+$/,
            regexpcoupon :/^[a-zA-Z0-9]{8,16}$/,
            trigger:false,
        }
        
    }
      addDefaultSrc(ev){
          ev.target.src =  require('../../assets/img/howzu-logo-default.png')
        }
         onChangeScratch(e){
          
            if (e.target.value === '' || this.state.regexp.test(e.target.value)) { 
        this.setState({
            scratchinputvalue:e.target.value,
            
        });
    }
  
  }
  onChangeCoupon(e){

    // if (e.target.value === '') { 
        this.setState({
            couponinputvalue:e.target.value,
            
        });
    // }
    // alert(this.state.couponinputvalue);
  }


    showModal4(modal) {
        this.setState({
            [modal]: true,
            activeTab: '4'
        });
    }
     closeModal(tabId) {
        this.setState({
            [tabId]: false
        });
        //  var hosturl = localStorage.getItem('web_url');  
        //  hosturl = hosturl+"app/wallet";  
        //    console.log("Hosturl="+hosturl);
        // window.location.assign(hosturl);
        //this.props.history.push("/app/wallet"); 
        this.setState({ modal4: false });
    }
     homeLink() { 
   
        // alert(this.state.trigger);
        if(this.state.trigger === true)
        {
        var hosturl = localStorage.getItem('web_url');  
         hosturl = hosturl+"app/wallet";  
         console.log("Hosturl="+hosturl);
         this.props.history.push("/app/wallet");
         window.location.reload();
        
        }
        else{
            // alert(this.state.trigger);
       this.setState({ modal4: false });
        }
    }
    componentDidMount(){
      //  if(!this.props || this.props.location.paytype===undefined){
      //    this.props.history.push("/app/Profile"); 
      //    return false;
      //   }
      //   console.log('paytype',this.props.location.paytype.type);
      //   const payment_type=this.props.location.paytype.type || "";
      //    this.setState({
      //       payment_type:payment_type
      //    });    
      
      }

     
    
    paywithscratchcard(paytype){

        //   alert(paytype);
        // return false;
        // var backage_id = this.props.location.backage_id.backage_id || "";
     
         // console.log("payment_type="+this.state.payment_type);
         
         var datalist = new FormData();   
          datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
          datalist.set('language', this.state.langKey); 
       
          if(paytype == 'scratch')
          {
          var purchase_type = 'wallet';  
          var change = this.state.scratchinputvalue.replace(/-/g, "");
         
          if(change=="" || !change || change.length<16){
            console.log("empty");
            this.setState({
            isError:true
         });    
            return false;
          }
          else{
               
               this.setState({
                 
            isError:false
         });   
          }
        }
        else{
          var purchase_type = 'coupon';
          var change = this.state.couponinputvalue;
          if(!change || change=="" || change.length < 3 || change.length > 16  ){
            console.log("empty");
            this.setState({
            isErrorc:true
         });    
            return false;
          }
          else{
          this.setState({
          isErrorc:false
         });   
          }
        
        }

          datalist.set('scratch_cardno', change); 
          // datalist.set('purchase_type', this.state.payment_type); 
           datalist.set('purchase_type', purchase_type); 


          // if(this.state.payment_type=='premium'){
          //   // console.log("check="+JSON.parse(localStorage.getItem('selected_premium')));
          //    datalist.set('id', backage_id); 
          // }
          // else if(this.state.payment_type=='boost'){
          //   // console.log("check="+JSON.parse(localStorage.getItem('selected_boostpremium')));

          // datalist.set('id', backage_id); 
          // }
          // else if(this.state.payment_type=='superlike'){
          //   // console.log("check="+JSON.parse(localStorage.getItem('selected_superlikepremium')));
          //    datalist.set('id', backage_id); 
          // }
         for (var value of datalist.values()) {
   console.log('datalist',value);
}
        //   return false;
      axios({
            method: 'post',
            url: this.state.api_url+'payscratchcard',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
             }}
              }).then(res => {
      

                if(res.data.status === 'true') {

                   
                    if(res.data.messageforweb == "Amount successfully added to your wallet" || res.data.messageforweb == 'Coupon Amount Recharged Successfully' || res.data.messageforweb == 'access_code')
                    {
                        // this.setState({
                        //     message: res.data.message});

                        this.setState({
                            trigger:true,
                            message: res.data.message});
                            this.setState({ modal4: true });
                           this.showModal4.bind(this, 'modal4')

                            
                        //    this.setState({ modal4: true });
                        //    this.showModal4.bind(this, 'modal4')
                           
                        //    localStorage.setItem('premium_popup', '1');
                        //   this.props.history.push("/app/Profile") 


                        //   var hosturl = localStorage.getItem('web_url');  
                        //   hosturl = hosturl+"app/wallet";  
                        // console.log("Hosturl="+hosturl);
                        // window.location.assign(hosturl);
                        // this.props.history.push("/app/wallet");
                    }
                    else{

                    this.setState({
                        message: res.data.message});
                        this.setState({ modal4: true });
                       this.showModal4.bind(this, 'modal4')
                       
                    }
                
                    
                } else {
                    this.setState({
                 message: res.data.message});
                 this.setState({ modal4: true });
                this.showModal4.bind(this, 'modal4')
                }



                
        }).catch(error => {
           this.props.history.push("/login"); 
        });
        
    }


    
    render() {
        const { t } = this.props;  

        const params = {
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          spaceBetween: 1,
          rebuildOnUpdate: true   
        }  

        const params2 = {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },  
            slidesPerView: 3,
            slidesPerColumn: 1,
            breakpoints: {
                360: {
                    slidesPerView: 3,
                },
                359: {
                    slidesPerView: 2,
                }
            }
        };
        var data=this.state.scratchinputvalue;

        var foo = data.split("-").join(""); // remove hyphens
  if (foo.length > 0) {
    foo = foo.match(new RegExp('.{1,4}', 'g')).join("-");
  }
  data = foo;

        return (

            <div className="setting-page">

               <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
                    <div class="heading-left-top d-flex">
                        <div className="align-self-center ">
                            <div className="iconHolder align-self-center mr-1">
                                <div className="backGlow  d-block d-lg-none">
                                <div className="backIco" onClick={() => this.setState({ showNav3: true })}></div>
                                </div>
                                <NavLink to={"/app/wallet"} >
                                 <div className="backGlow  d-block nonResp">
                                    <div className="backIco"></div>
                                </div>
                                </NavLink>
                            </div>
                        </div>
                        <span className="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="Scratch Card & Coupon">Scratch Card & Coupon</Trans></span>
                    </div>
                    <div className="backGlow white-bg"></div>
                </div> 
               

                <div className="container pt-50 scratchcontainer">



    <div class="row">
                       
        
    <div class="user-input-wrp amb25 col-sm-11 col-md-7 col-lg-7 col-xl-7 col-Resp col-xl-Resp scratch_input_container">
    <div class="box">
    <span class="arrow-center align-self-center  bold-font"><Trans i18nKey="Scratch card">Scratch card Details</Trans></span>
    <div class="">
    <input type="text" id="scratch" value={data}   maxLength={19}  onChange={this.onChangeScratch} className="inputText scratch_text" placeholder="XXXX-XXXX-XXXX-XXXX " required />  
    <button type="submit" className="btn btn-bg width10 scratch_button" onClick={this.paywithscratchcard.bind(this,'scratch')} /*onClick={this.paywithscratchcard} */> <Trans i18nKey="Apply">Apply</Trans> </button>
    {this.state.isError && <p className="errorMsg"><Trans i18nKey="Enter valid scratch card number">Enter valid scratch card number</Trans> </p>}      
    </div>
        </div>
        </div>
    </div>




    <div class="row">
                       
    <div class="user-input-wrp amb25 col-sm-11 col-md-7 col-lg-7 col-xl-7 col-Resp col-xl-Resp scratch_input_container">
	<div class="box">
		<span class="arrow-center align-self-center bold-font"><Trans i18nKey="Coupon code">Coupon code Details</Trans></span> 
		<div class="">
        <input type="text" id="code-detail"    maxLength={19}  onChange={this.onChangeCoupon} className="inputText scratch_text" placeholder={t('Enter coupon code')}  required />
        
		</div>
		<button type="submit" className="btn btn-bg width10 scratch_button" data-toggle="modal" onClick={this.paywithscratchcard.bind(this,'coupon')}  data-target="#exampleModalCenter"><Trans i18nKey="Apply">Apply</Trans></button>

        {this.state.isErrorc && <p className="errorMsg"><Trans i18nKey="Enter valid coupon code">Enter valid coupon code</Trans> </p>}
	</div>
               </div></div>   
                 
                </div>




                 <Modal isOpen={this.state.modal4} toggle={this.closeModal.bind(this, 'modal4')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={this.closeModal.bind(this, 'modal4')}><h4 class="modal-title" style={{'marginTop':"10px"}}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                                <div class="mr-0"><button class="border-0 bg-white pink-color" onClick={this.homeLink}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal>
                  <div className="sidebarResp d-block d-lg-none">
                    <SideNav showNav={this.state.showNav3} onHideNav={() => this.setState({ showNav3: false })} title={<div></div>} items={[<SideBar />]} />
                </div>




            </div>
        )
    }

    
}

export default withTranslation("translations")(ScratchCard);